import { buildDefaultMulti } from './buildDefaultMulti';
import type { Line } from './Line';
import type { Multi, MultiDependencies } from './Multi';
import { Quantity } from './Quantity';
import { buildStretchDelimiter } from './StretchDelimiter';

export class AbsoluteValue extends Quantity {
  constructor(line: Line, multi: Multi) {
    super(line, multi, buildStretchDelimiter('|'), buildStretchDelimiter('|'));

    this.t = 'absoluteValue';
    this.gmmName = 'absolute value';
  }

  toXML(): string {
    return '<a>' + this.multi.toXML() + '</a>';
  }
}

export function buildAbsoluteValue(
  problemJS: MultiDependencies,
  line: Line,
  contents?: Multi
): AbsoluteValue {
  return new AbsoluteValue(
    line,
    contents || buildDefaultMulti(problemJS, line)
  );
}
